const idPortalApi = "4b098ab7f4b6639eb7cf631fdae66d043eca40f8";

module.exports = {
  tokenLink: idPortalApi,
  urlApi: `https://api-portais-workcenter.com.br/${idPortalApi}`,
  link: "http://www.transparenciadministrativa.com.br",
  urlADM: `https://administracaopublica.com.br`,
  linkArquivos: "http://www.transparenciadministrativa.com.br/portalimagem",
  imagemURL: "https://cdn.administracaopublica.com.br/complementares/",

  // urlApi: `http://localhost:8004/${idPortalApi}`,
  //imagemURL: 'http://localhost:8004/uploads/', //link para a imagem

  urlEmDeploy: "https://www.camarajoaocosta.pi.gov.br/", //usada para link de compartilhamento
  dnsPortal: "camarajoaocosta.pi.gov.br",
  NomePortal: "João Costa do Piauí", //Nome do municipio
  ufPortal: "PI",
  NomeTipoPortal: "Câmara Municipal", //Prefeitura ou Câmara
  TipoPortal: 4, //3 = Prefeitura 4 = Câmara

  //Variável em teste (newsViewRoute)
  newsViewRoute: true,
  countNewsHome: 12, //quantidade de noticias na home
  RoutesDaily: true, //Deixa ativado as rotas para a pagina de diario
  corIcones: "#b28e08",

  //links externos
  link_youtube: `https://youtube.com/@camarajoaocosta-pi?si=OT_sUksSLrmZbQEc`,
  link_tiktok: `#`,
  link_twitter: `#`,
  link_threads: `#`,
  link_localize: `https://maps.app.goo.gl/QmaLqhH4RcWRgiaSA`,
  //Mapa da pagina Municipio/Mapa
  link_mapa:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15784.363764047637!2d-42.422456048981516!3d-8.490538602002587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7777a3623e2fa27%3A0x770bd43116ef737f!2sJo%C3%A3o%20Costa%2C%20State%20of%20Piau%C3%AD%2C%2064765-000!5e0!3m2!1sen!2sbr!4v1747620602267!5m2!1sen!2sbr",
};
